<autocomplete-list-item (clicked)="triggerEvent()"> {{ item.postalCode }} {{ item.city }} </autocomplete-list-item>
